import React from 'react';
import { Card } from './styles';
import { Button, Progress, Tooltip } from 'antd';
import { withTranslation } from 'react-i18next';
import { HYBRID_MAIL_ROOM } from '../Dashboard/StatusMonitoring/HybridMail/TranslationValue';
import { dateTimeConversion } from '../../utils/javascript';
import { FilesIcon, splitDocIcon } from '../../images/svgIcons';
import { BATCH_LIST } from '../MailRoom/translationValues';

const NAMESPACES = ['HYBRID_MAIL_ROOM'];

const splitType = t => ({
  address: t(BATCH_LIST.SPLIT_TYPE_ADDRESS.key, BATCH_LIST.SPLIT_TYPE_ADDRESS.value),
  pageCount: t(BATCH_LIST.SPLIT_TYPE_PAGE_COUNT.key, BATCH_LIST.SPLIT_TYPE_PAGE_COUNT.value),
});

const BatchList = props => {
  const { showFileUpload, batchList, setBatchData, t } = props;
  return (
    <>
      <Card height={'200px'} width={'294px'} padding={'24px'} className={'createBatchCard'}>
        <div>
          <h2 className="createBatchTitle">
            {t(HYBRID_MAIL_ROOM.SEND_LETTERS_TITLE.key, HYBRID_MAIL_ROOM.SEND_LETTERS_TITLE.value)}
          </h2>
          <p className="createBatchDescription">
            {t(HYBRID_MAIL_ROOM.UPLOAD_TEXT.key, HYBRID_MAIL_ROOM.UPLOAD_TEXT.value)}
          </p>
        </div>
        <div className="createCard">
          <Button
            onClick={() => {
              showFileUpload(true);
            }}
          >
            {t(HYBRID_MAIL_ROOM.GET_STARTED_BUTTON.key, HYBRID_MAIL_ROOM.GET_STARTED_BUTTON.value)}
          </Button>
        </div>
      </Card>

      {batchList?.map((li, key) => {
        return (
          <Card
            key={key}
            className={'batchCard'}
            height={'200px'}
            width={'294px'}
            status={'success'}
            animation={true}
            animationDelay={key < 10 ? key * 200 + 'ms' : ''}
          >
            <Progress
              percent={100}
              status={'success'}
              showInfo={false}
            />
            <div className="cardBody">
              <p className="createdOn">{dateTimeConversion(li.createdOn, true, true, false)}</p>
              <Tooltip key={li.batchId} placement="top" title={li.batchName}>
                <h2 className="batchTitle" onClick={() => setBatchData(li)}>
                  {li.batchName}
                </h2>
              </Tooltip>
              {/* <p className="batchDescription">{li.description || '-'}</p> */}
              <div className="batchDetails">
                <div>
                  {FilesIcon()}
                  <p>{t(BATCH_LIST.FILES_LABEL.key, BATCH_LIST.FILES_LABEL.value)}:</p>
                  <p>{li.totalFiles}</p>
                </div>
                <div>
                  {splitDocIcon()}
                  <p>{t(BATCH_LIST.SPLIT_TYPE.key, BATCH_LIST.SPLIT_TYPE.value)}:</p>
                  <p>{splitType(t)[li.splitType]}</p>
                </div>
              </div>
            </div>
          </Card>
        );
      })}
    </>
  );
};
export default withTranslation(NAMESPACES)(BatchList);
